import {Tree, TreeCheckboxSelectionKeys} from 'primereact/tree';
import {TreeNode} from 'primereact/treenode';

interface InterestsStepProps {
  sectorTreeNodes: TreeNode[];
  selectedNodes: TreeCheckboxSelectionKeys | null;
  expandedKeys: Record<string, boolean>;
  isLoading: boolean;
  selectedInterests: Array<{tid: string; name: string}>;
  onSelectionChange: (nodes: TreeCheckboxSelectionKeys | null) => void;
  onExpandedChange: (keys: Record<string, boolean>) => void;
  onRemoveInterest: (tid: string) => void;
  onSubmit: () => void;
}

export const InterestsStep = ({
  sectorTreeNodes,
  selectedNodes,
  expandedKeys,
  isLoading,
  selectedInterests,
  onSelectionChange,
  onExpandedChange,
  onRemoveInterest,
  onSubmit,
}: InterestsStepProps) => {
  const hasSelection = selectedNodes && Object.keys(selectedNodes).length > 0;

  return (
    <div className="step-content step-3">
      <p className="step-subtitle">Let's set up your profile!</p>
      <h2 className="step-title">What are your interests?</h2>

      {selectedInterests.length > 0 && (
        <div className="selected-interests">
          {selectedInterests.map((interest) => (
            <div key={interest.tid} className="interest-chip">
              <span>{interest.name}</span>
              <button type="button" onClick={() => onRemoveInterest(interest.tid)}>
                <i className="pi pi-times"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="form-group">
        <div className="interests-tree-container">
          {isLoading ? (
            <div style={{textAlign: 'center', padding: '2rem'}}>
              <p>Loading interests...</p>
            </div>
          ) : (
            <Tree
              value={sectorTreeNodes}
              selectionMode="checkbox"
              selectionKeys={selectedNodes}
              onSelectionChange={(e) => onSelectionChange(e.value as TreeCheckboxSelectionKeys)}
              expandedKeys={expandedKeys}
              onToggle={(e) => onExpandedChange(e.value)}
              className="interests-tree"
              filter
              filterPlaceholder="Search interests..."
            />
          )}
        </div>
      </div>

      <button type="button" className="submit-button" onClick={onSubmit} disabled={!hasSelection}>
        Continue
      </button>
    </div>
  );
};
